"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var jsx_runtime_1 = require("react/jsx-runtime");
var styles_1 = require("@mui/material/styles");
var sum_1 = __importDefault(require("lodash/sum"));
var react_1 = __importStar(require("react"));
var react_redux_1 = require("react-redux");
var react_router_dom_1 = require("react-router-dom");
var FilterButtonSimple_1 = __importDefault(require("components/Buttons/Specific/FilterButtonSimple"));
var ButtonsHolder_1 = __importDefault(require("components/Inputs/Buttons/ButtonsHolder"));
var single_1 = require("utils/selectors/single");
var constants_1 = require("./constants");
var utils_1 = require("./utils");
var PREFIX = 'OptimiseFilters';
var classes = {
    wrapper: "".concat(PREFIX, "-wrapper"),
    heading: "".concat(PREFIX, "-heading"),
    buttonsHolder: "".concat(PREFIX, "-buttonsHolder"),
};
var Root = (0, styles_1.styled)('div')(function (_a) {
    var _b;
    var theme = _a.theme;
    return (_b = {},
        _b["&.".concat(classes.wrapper)] = {
            width: 'calc(100% - 28px)',
            display: 'flex',
            justifyContent: 'space-between',
            marginLeft: theme.spacing(1),
        },
        _b[".".concat(classes.heading)] = {
            fontSize: 20,
            fontWeight: theme.typography.fontWeightMedium,
            color: theme.palette.text.secondary,
            letterSpacing: '0.023em',
            marginRight: theme.spacing(2),
        },
        _b[".".concat(classes.buttonsHolder)] = {
            display: 'inline-block',
        },
        _b);
});
var STATUS_MAP = {
    toAction: 'to action', inProgress: 'in progress', actioned: 'actioned',
};
var STATUS_COLOR_MAP = { toAction: 'purple', inProgress: 'yellow', actioned: 'green' };
var OptimiseFilters = function (_a) {
    var ownersToFilterBy = _a.ownersToFilterBy, setStatusToFilterBy = _a.setStatusToFilterBy, statusToFilterBy = _a.statusToFilterBy, sortedRecommendations = _a.sortedRecommendations;
    var auth = (0, react_redux_1.useSelector)(single_1.selectAuth);
    var statusSummary = (0, react_1.useMemo)(function () { return (0, utils_1.summarizeRecommendationsPerStatus)(sortedRecommendations); }, [ownersToFilterBy, (0, react_router_dom_1.useLocation)()]);
    var isOwn = ownersToFilterBy.length === 1 && ownersToFilterBy[0] === auth.uid;
    var partialSummary = (0, utils_1.getFormattedStatusSummary)(statusSummary, ownersToFilterBy, STATUS_MAP);
    return ((0, jsx_runtime_1.jsx)(Root, __assign({ className: classes.wrapper, id: "scrollToDiv" }, { children: (0, jsx_runtime_1.jsxs)("div", { children: [(0, jsx_runtime_1.jsxs)("span", __assign({ className: classes.heading, onClick: function () { return setStatusToFilterBy(null); } }, { children: [isOwn ? 'Your' : 'All', " tasks (", partialSummary ? (0, sum_1.default)(Object.values(partialSummary)) : 0, ")"] })), (0, jsx_runtime_1.jsx)(ButtonsHolder_1.default, __assign({ className: classes.buttonsHolder }, { children: constants_1.statuses.map(function (status) { return ((0, jsx_runtime_1.jsxs)(FilterButtonSimple_1.default, __assign({ selected: statusToFilterBy === status, onClick: function () { return setStatusToFilterBy(statusToFilterBy !== status ? status : null); }, color: STATUS_COLOR_MAP[status] }, { children: [partialSummary === null || partialSummary === void 0 ? void 0 : partialSummary["".concat(status, "Count")], " ", STATUS_MAP[status]] }), status)); }) }))] }) })));
};
exports.default = react_1.default.memo(OptimiseFilters);
